import React from 'react';
import ChatContainer from '../ChatContainer/ChatContainer';
import Header from '../Header/Header';
const App = () => {
    return (
        <div>
            <Header />
            <ChatContainer />
        </div>
    );
};

export default App;
